import { DeliveryStatusTypeEnum, DriverConfirmEnum, InvoiceType, StatusEnum } from '@app/@core/enums';
import moment from 'moment'

export class RouteDeliveryModel {
  constructor(id: number, name: string, viewIndex: number, routes: Array<RouteModel>) {
    this.driverId = id;
    this.driverName = name;
    this.viewIndex = viewIndex;
    this.routes = routes;
  }
  deliveryId: number;
  driver: any;
  driverId: number;
  vehicleId: number;
  driverName: string;
  viewIndex: number;
  routes: RouteModel[];
  isNew: boolean;
  status: StatusEnum;
  inactiveDate?: Date;
}

export class RouteModel {
  routeId: number;
  routeName: string;
  driverId: number;
  driverOrginId: number;
  driver: any;
  vehicle: any;
  vehicleId: number;
  originalVehicleId: number;
  vehicleName: string;
  customerId: number; // use for edit/add single customer into route
  deliveryId: number;
  deliveries: CustomerModel[];
  date: moment.Moment;
  routeDay: number;
  routeStartDate: moment.Moment;
  routeEndDate: moment.Moment;
  deliveryType: number;
  recurringType: number;
  weekOfMonth: number;
  biWeeklyType: number;
  startPointAddress1: any;
  startPointAddress2: any;
  startPointCity: any;
  startPointState: any;
  startPointZipCode: any;
  startPointCountry: any;
  startPointLongitude: any;
  startPointLatitude: any;
  optimizeRoute: number;
  isStartedToday: boolean;
  isLoading: boolean = false;
  constructor(data: any) {
    if (data) {
      this.routeId = data.id ?? data.routeId;
      this.routeName = data.name ?? data.routeName;
      this.driverId = data.driverId;
      this.driverOrginId = data.driverId;
      this.driver = data.driver;
      this.vehicle = data.vehicle;
      this.vehicleId = data.vehicleId;
      this.originalVehicleId = data.vehicleId;
      this.vehicleName = data.vehicleName;
      this.customerId = data.customerId; // use for edit/add single customer into route
      this.deliveryId = data.deliveryId;
      this.deliveries = data.deliveries ?? [];
      this.date = data.date;
      this.routeDay = data.routeDay;
      this.routeStartDate = data.startDate;
      this.routeEndDate = data.endDate;
      this.deliveryType = data.deliveryType;
      this.recurringType = data.recurringType;
      this.weekOfMonth = data.weekOfMonth;
      this.biWeeklyType = data.biWeeklyType;
      this.startPointAddress1 = data.startPointAddress1;
      this.startPointAddress2 = data.startPointAddress2;
      this.startPointCity = data.startPointCity;
      this.startPointState = data.startPointState;
      this.startPointZipCode = data.startPointZipCode;
      this.startPointCountry = data.startPointCountry;
      this.startPointLongitude = data.startPointLongitude;
      this.startPointLatitude = data.startPointLatitude;
      this.optimizeRoute = data.optimizeRoute;
      this.isStartedToday = data.isStartedToday;
    }
  }
}

export class CustomerModel {
  id: number;
  deliveryId: number;
  routeId: number;
  driverId: number;
  vehicleId: number;
  dayOfWeek: number;
  startDate: moment.Moment;
  endDate: moment.Moment;
  startPointLongitude: string;
  startPointLatitude: string;
  name: string;
  deliveryType: number;
  recurringType: number;
  weekOfMonth: number;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  preferDeliveryDays: string;
  order: any;
  driverConfirm: DriverConfirmEnum;
  deliveryStatus: DeliveryStatusTypeEnum;
  invoiceId: number;
  invoiceType: InvoiceType;
  constructor(data = null) {
    if (data) {
      this.id = data.id;
      this.deliveryId = data.deliveryId;
      this.routeId = data.routeId;
      this.dayOfWeek = data.dayOfWeek;
      this.startDate = data.startDate;
      this.endDate = data.endDate;
      this.startPointLongitude = data.startPointLongitude;
      this.startPointLatitude = data.startPointLatitude;
      this.name = data.name;
      this.deliveryType = data.deliveryType;
      this.recurringType = data.recurringType;
      this.weekOfMonth = data.weekOfMonth;
      this.address = data.address;
      this.city = data.city;
      this.state = data.state;
      this.zipCode = data.zipCode;
      this.preferDeliveryDays = data.preferDeliveryDays;
      this.order = data.order;
      this.driverConfirm = data.driverConfirm;
      this.deliveryStatus = data.deliveryStatus;
      this.invoiceId = data.invoiceId;
      this.invoiceType = data.invoiceType;
      this.driverId = data.driverId;
      this.vehicleId = data.vehicleId;

    }
  }
}
